<template>
  <div>
    <EditButton
      :disabled="!$atividades.permissoes.includes(14)"
      @func="modalEditarSegmento = true"
    ></EditButton>
    <SideBar
      title="Editar segmento"
      @hide="cancelar"
      :active="modalEditarSegmento"
      :item="segmento"
      textSucces="Atualizar"
      :disabled="!$atividades.permissoes.includes(15)"
      @excluir="excluirSegmento"
      @status="mudarStatusSegmento"
      @success="submitForm()"
      size="small"
    >
      <div slot="body">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              name="nome"
              v-validate="'required'"
              label-placeholder="Nome"
              v-model="segmento.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  name: "modalEditarSegmento",
  props: { segmento: Object },
  data() {
    return {
      modalEditarSegmento: false,
      error: false,
      originalData: {}
    };
  },
  mounted() {
    this._beforeEditingCache = Object.assign({}, this.segmento);
    this.originalData = this.segmento;
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.editarSegmento();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async editarSegmento() {
      this.$validator.validateAll().then(async result => {
        if (result) {
          this.$vs.loading();
          try {
            const res = await this.$http.put(
              `segmento/${this.segmento.id}`,
              this.segmento
            );
            let logData = {
              id_colaborador: localStorage.getItem("id"),
              funcao: "atualizar",
              setor: "comercial",
              ip: window.localStorage.getItem("ip"),
              texto: "Edição do segmento N°" + res.id
            };
            await this.$logger(logData);
            this.modalEditarSegmento = false;
          } catch (err) {
            const error = this.$httpErrors(err);
            this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
          } finally {
            this.$vs.loading.close();
          }
        }
      });
    },
    async excluirSegmento() {
      this.$vs.loading();
      try {
        const res = await this.$http.delete(`segmento/${this.segmento.id}`);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "excluir",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Exclusão do segmento N°" + res.id
        };
        await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarSegmento = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    async mudarStatusSegmento() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(`segmento/${this.segmento.id}`, {
          lixeira: !this.segmento.lixeira
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Mudar status do segmento N°" + res.id
        };
        await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarSegmento = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    cancelar() {
      Object.assign(this.segmento, this._beforeEditingCache);
      this.originalData = this._beforeEditingCache = null;
      this.modalEditarSegmento = false;
    }
  },
  components: components
};
</script>

<style></style>
